export default "__VITE_ASSET__DbieccXT__"